import * as React from "react"
import { InputGroup, InputGroupAddon, InputGroupTextarea } from "@design/ui/input-group"

export interface WebChatWiring {
  greetingGreeting?: string
  inputGroup: Omit<React.ComponentProps<typeof InputGroup>, "className" | "children">
  inputGroupContent?: React.ReactNode
  inputGroupInput: Omit<React.ComponentProps<typeof InputGroupTextarea>, "placeholder">
  inputGroupAddon: Omit<React.ComponentProps<typeof InputGroupAddon>, "align" | "children">
  inputGroupAddonSlot?: React.ReactNode
}

export const WebChatContext = React.createContext<WebChatWiring | null>(null)

export function useWiring(): WebChatWiring {
  const wiring = React.useContext(WebChatContext)
  if (wiring === null) {
    throw new Error("WebChatScreen: render inside <WebChatContext.Provider>")
  }
  return wiring
}
